import {useRouteMatch, Switch, Route, Redirect} from 'react-router-dom';

import Customers from './Customers';
import Employees from './Employees';
import Teams from './Teams';

function Settings() {
  const {path} = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/customers`} exact component={Customers} />
        <Route path={`${path}/employees`} exact component={Employees} />
        <Route path={`${path}/teams`} exact component={Teams} />
        <Redirect to={`${path}/customers`} />
      </Switch>
    </>
  );
}

export default Settings;
